<div class="d-flex flex-column h-100" id="livePreview">
  <div id="alLivePreview" class="al_live_preview" *ngIf="presentPage === assetsPage">
    <!-- TODO need to check this condtion afterwards we will remove this commented code -->
    <!-- <iposcen-content-live-preview *ngIf="(presentPage === profilePage && (tabIndex === 0 || tabIndex === 1))"
    [sidenav]="pageType"></iposcen-content-live-preview> -->
    <iposcen-content-live-preview [sidenav]="pageType" [sendctavalue]="sendctavalue" *ngIf="tabIndex === 1">
    </iposcen-content-live-preview>
  </div>
  <div id="profileTxt" *ngIf="presentPage === profilePage" class="profile-text">
    <div id="profileName" class="profile-name-title">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileDataSet?.profileName}}</h2>
  </div>
  <div id="contentLive" class="al_live_preview" *ngIf="presentPage === profilePage">
    <iposcen-content-live-preview [sidenav]="pageType" [tileSRT]="isSrtEnabled" [herotilePresentPage]="presentPage" [herotiletabIndex]="tabIndex" *ngIf="tabIndex === 1 || tabIndex === 0">
    </iposcen-content-live-preview>
  </div>
  <!-- Main section -->
  <section *ngIf="tabIndex === 0" class="main_section al_storepromo" [ngClass]="{'main-tabs-switch':isSrtEnabled && isCustomTileEnabled}">
    <div *ngIf="tabIndex === 0" id="heroTileContent">
      <div>
      <div id="tabMain" class="tabs-main" [ngClass]="{'profile-tabs-main':presentPage === profilePage}" *ngIf = "(isSrtEnabled && isCustomTileEnabled)">
        <ng-container>
          <div id="langTab" class="tab" (click)="tabChange('custom-content')" [ngClass]="{'active-tab':isCustomContentTabActive,'inactive-tab':!isCustomContentTabActive, 
                            'french-width': isFrench, 'greek-width': isGreek || isPortugese || isRussian, 
                            'italian-width' : isItalian || isSpanish,'polish-width': isPolish}">
            <span i18n="@@hero-tile.asset-library.custom-main-tile-content">CUSTOM MAIN TILE CONTENT</span>
          </div>
          <div id="srtTab" class="tab" (click)="tabChange('srt-content')"
            [ngClass]="{'active-tab':isSrtTabActive ,'inactive-tab':!isSrtTabActive,'italian-width' : isItalian,'spanish-width': isSpanish}">
            <span i18n="@@hero-tile.asset-library.intel-shopper-recommendation-tool">INTEL® SHOPPER RECOMMENDATION TOOL</span>
          </div>
        </ng-container>
      </div>
    </div>
    <div id="profileTabs" [ngClass]="{'profile-main-section-tabs' : (presentPage === profilePage && isSrtEnabled && isCustomTileEnabled) ,'main-section-tabs' : (presentPage === assetsPage && isSrtEnabled && isCustomTileEnabled)}">
      <div id="mainSec" class="main_section_headers" *ngIf="((presentPage === assetsPage || presentPage === profilePage) && !enableCustomSrt && isCustomTileEnabled)">
        <svg class="header_icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.5 3H1.5V21H22.5V3ZM1.5 1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3L0 21C0 21.3978 0.158035 21.7794 0.43934 22.0607C0.720644 22.342 1.10218 22.5 1.5 22.5H22.5C22.8978 22.5 23.2794 22.342 23.5607 22.0607C23.842 21.7794 24 21.3978 24 21V3C24 2.60218 23.842 2.22064 23.5607 1.93934C23.2794 1.65804 22.8978 1.5 22.5 1.5H1.5Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11.25 21V3H12.75V21H11.25ZM11.25 9H1.5V7.5H11.25V9ZM22.5 16.5H12.75V15H22.5V16.5Z" />
        </svg>
        <span i18n="@@hero-tile.asset-library.custom-main-tile-content">CUSTOM MAIN TILE CONTENT</span>
      </div>
      <div id="mainSecHeaders" class="main_section_headers" *ngIf="(presentPage === assetsPage && !enableCustomSrt && isSrtEnabled) || (userRole === intelAdmin)">
        <svg class="header_icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M22.5 3H1.5V21H22.5V3ZM1.5 1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3L0 21C0 21.3978 0.158035 21.7794 0.43934 22.0607C0.720644 22.342 1.10218 22.5 1.5 22.5H22.5C22.8978 22.5 23.2794 22.342 23.5607 22.0607C23.842 21.7794 24 21.3978 24 21V3C24 2.60218 23.842 2.22064 23.5607 1.93934C23.2794 1.65804 22.8978 1.5 22.5 1.5H1.5Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11.25 21V3H12.75V21H11.25ZM11.25 9H1.5V7.5H11.25V9ZM22.5 16.5H12.75V15H22.5V16.5Z" />
        </svg>
        <span i18n="@@hero-tile.asset-library.intel-shopper-recommendation-tool">INTEL® SHOPPER RECOMMENDATION TOOL</span>
      </div>

      <!-- Data header with info like no. of content groups, action buttons and filters -->
      <div id="SRTContent" class="data_header"
        *ngIf="displayHeroTiles?.length === 0 && (userRole === retailHQUser || userRole === storeUser || userRole === regionalHQ) && presentPage === assetsPage">
        <div id="SRTMsg" class="font-style" *ngIf="tabActive === globalconst.SRT_CONTENT">
          <ng-container *ngTemplateOutlet = "noDataMessage"></ng-container>
        </div>
        <div id="SRTData" class="font-style" *ngIf="tabActive === globalconst.CUSTOM_CONTENT">
          <ng-container *ngTemplateOutlet = "noDataCustomTile"></ng-container>
        </div>
        <span *ngIf="allHeroTile?.length === 0 && globalconst.CUSTOM_CONTENT === tabActive" i18n="@@hero-tile.asset-library.add-custom-content-to-main">Add Custom Content to the Main Tile by creating a new one</span>
      </div>
      <div id="displayHeros" class="data_header" *ngIf="displayHeroTiles?.length === 0 && userRole === intelAdmin"><span
          i18n="@@hero-tile.asset-Library.admin-no-content">Add a Main Tile Asset to allow launching of the Intel®
          Shopper Recommendation Tool (SRT) from a URL or Executable File (exe).</span></div>
      <div id="displayHeroData" *ngIf="presentPage === assetsPage" class="data_header"
        [ngClass]="(displayHeroTiles?.length > 0)?'':'display-block'">
        <span *ngIf="displayHeroTiles?.length > 0" class="data-header-rtl">
          <span *ngIf="displayHeroTiles" id="dataTitle"> {{displayHeroTiles?.length}}
            <span *ngIf="globalconst.SRT_CONTENT === tabActive" i18n="@@hero-tile.asset-library.intel-shopper-recommendation-tool-content-groups">Intel® Shopper Recommendation Tool Content Groups</span>
            <span *ngIf="globalconst.CUSTOM_CONTENT === tabActive" i18n="@@hero-tile.asset-library.custom-main-tile-content-groups">Custom Main Tile Content Groups</span></span>
          <span *ngIf="displayHeroTiles?.length > 1">
            <span class="sort-by-label" i18n="@@hero-tile.data-header.sort">Sort by</span>: &nbsp;
            <div id="heroDropDown" ngbDropdown class="btn-group">
              <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle" id="sortDropDown">{{sortValue}}
              </button>
              <div id="heroDropDownMenu" ngbDropdownMenu aria-labelledby="sortDropDown">
                <button ngbDropdownItem *ngIf="sortValue!=createdDateVal" class="sortDropDown" (click)="sortByDate()">
                  {{createdDateVal}}
                </button>
                <button ngbDropdownItem *ngIf="sortValue!=groupNameVal" class="sortDropDown" (click)="sortByName()">
                  <span i18n="@@hero-tile.dropdown.group">Group Name</span>
                </button>
              </div>
            </div>
          </span>
        </span>
        <span class="data_action" *ngIf="presentPage === assetsPage && userRole === intelAdmin">
          <button type="button" id="uploadpromo"
            class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryHeroTileNewHeroTile"
            (click)="createNewHeroTile()">
            <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                  fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@hero-tile.asset-library.create-new-asset">Create New Asset</span>
          </button>
        </span>
        <ng-container *ngTemplateOutlet="addButtonCustom"></ng-container>
      </div>

      <div id="cpSec" class="main_section_cp_sections cp_sections"  [ngClass]="isDeviceMainTile ? 'custom-padding' : ''">
        <div id="cpData" class="data_header" *ngIf="presentPage === profilePage && (isSrtEnabled !== isCustomTileEnabled)">
          <span i18n="@@hero-tile.asset-library.intel-shopper-recommendation-tool-lowercase" class="data_title" *ngIf="(isSrtEnabled !== isCustomTileEnabled) && tabActive === globalconst.SRT_CONTENT">Intel® Shopper Recommendation Tool</span>
        </div>
        <!-- ashutosh - enabled linux for added new custom tile by adding operatingSystem === linux  -->
        <div id="dataInfo" class="data_info d-flex"
          *ngIf="presentPage === profilePage && displayHeroTiles?.length > 0 && (operatingSystem === windows || operatingSystem === windows10S || operatingSystem === linux)">
          <span *ngIf="tabActive === globalconst.SRT_CONTENT" i18n="@@hero-tile.asset-library.choose-intel-shopper">Choose Intel® Shopper Recommendation Tool Content Group to appear on IPOS</span>
          <div id="tabNote" *ngIf="tabActive === globalconst.CUSTOM_CONTENT" class="custom-tab-note">
            <!--IIT2-6238 starts-->
            <div id="tabNoteData" class="mb-3" *ngIf="(isSrtEnabled && isCustomTileEnabled) && tabActive === globalconst.CUSTOM_CONTENT">
              <span i18n="@@hero-tile.asset-library.custom-srt-added-as-asset"><strong>Note:</strong> The Custom content and Intel® SRT can both be added as assets in the Main Tile.</span>
            </div>
            <div>
              <div id="add2Pckg" *ngIf="displayHeroTiles?.length > 0">
                <strong><span i18n="@@price-content.price-content-groups.add-to-package">Added to
                    Package</span>:</strong>
                {{ selctedContGrpsForProfile?.contentGrps?.length || '0'}}
                <span i18n="@@segments.content-groups-label">Content Groups</span>
              </div>
              <div id="showOnDevice" *ngIf="displayHeroTiles?.length > 0">
                <strong><span i18n="@@price-content.price-content-groups.show-on-device">Show on Device</span>:</strong>
                {{ selctedContGrpsForProfile?.showOnDevice ? '1': '0'}}
                <span i18n="@@segments.content-groups-label">Content Groups</span>
              </div>
            </div>
            <div id="subtitle" class="custom-subtitle"><span i18n="@@create-profile.hero-tile.three-custom-main-tile-content-groups"><strong>You may show 1 Custom Main Tile Content, and you can add up to 3 Custom Main Tile Content Groups to the package.</strong></span></div>
           <!--IIT2-6238 ends-->
          </div>
          <div id="addButtonCustom" class="container-button" *ngIf="tabActive === globalconst.CUSTOM_CONTENT">
            <ng-container *ngTemplateOutlet="addButtonCustom"></ng-container>
          </div>
        </div>
        <div class="data_info mb-3"
          *ngIf="presentPage === profilePage  && displayHeroTiles?.length === 0 &&  (operatingSystem === windows || operatingSystem === linux || operatingSystem === windows10S)">
          <div id="noDataMessage" class="font-style" [ngClass]="{'mt-3':isSrtEnabled && isCustomTileEnabled}" *ngIf="tabActive === globalconst.SRT_CONTENT && operatingSystem !== linux">
            <!-- <span i18n="@@hero-tile.descriptive-text">An Intel Admin has enabled you to use a customized Main Tile
              Asset.</span> -->
              <ng-container *ngTemplateOutlet = "noDataMessage"></ng-container>
          </div>
        
          <div id="noDataCustomTile" class="font-style" [ngClass]="{'mt-3':isSrtEnabled && isCustomTileEnabled}" *ngIf="tabActive === globalconst.CUSTOM_CONTENT">
            <ng-container *ngTemplateOutlet = "noDataCustomTile"></ng-container>
          </div>
          <div id="addButtonCustom" class="container-button mt-3" *ngIf="tabActive === globalconst.CUSTOM_CONTENT">
            <ng-container *ngTemplateOutlet="addButtonCustom"></ng-container>
          </div>
        </div>
        <div id="dataInfoDesc" class="data_info mb-3">
          <div id="dataInfoTxt" *ngIf="(presentPage === profilePage &&  operatingSystem === chrome) || (presentPage === profilePage &&  operatingSystem === linux && tabActive === globalconst.SRT_CONTENT)">
            <span i18n="@@hero-tile.data-info-desc">The Main Tile may be packaged with Windows* and Windows* in S Mode profiles.</span>
          </div>
          <div id="chromeTxt">
            <span *ngIf="presentPage === profilePage &&  operatingSystem === linux &&
             tabActive === globalconst.SRT_CONTENT" i18n="@@hero-tile.does-not-apply-to-linux-and-chromebook">It does not apply for Linux* and Chromebook*.</span>
            <span *ngIf="presentPage === profilePage &&  operatingSystem === chrome" i18n="@@hero-tile.does-not-apply-for-chromebook">It does not apply for Chromebook*</span>
          </div>
        </div>
        <div id="segments" class="data_content segments_only"
          *ngIf="displayHeroTiles?.length > 0  && operatingSystem !== chrome"
          [ngClass]="presentPage === profilePage?'acc_table_view':''">
          <div id="showOnDeviceSelect" class="show_on_device_select" *ngIf="presentPage === profilePage">
            <div id="showOnDeviceLabel" class="small_text border-right shown-on-device-label">
              <span i18n="@@segments.shown-on-device-label">Show on Device</span>
            </div>
            <div id="grpLabels"><span i18n="@@segments.content-groups-label">Content Groups</span></div>
          </div>
          <div class="accordion" id="logoContentAccordian">
            <!-- Group 1 -->
            <div id="deviceMainTile" class="card" *ngIf="(presentPage === profilePage) || isDeviceMainTile" [ngClass]="isDeviceMainTile ? 'custom-card':''">
              <div id="tileCard" class="card">
                <div id="segmentOne" class="card-header small_text">
                  <div id="accCheck" class="acc_check">
                    <div id="deviceMainRadio" class="form-check">
                      <input type="radio" name="cpHeroSelect" class="form-check-input" value="isCustomNone" [checked]="isCustomNone"
                        (change)="removeHeroTile()">
                    </div>
                  </div>
                  <div class="card-header-content ">
                    <div class="title_left none_title_left">
                      <div class="d-flex">
                        <div class="none_title">
                          <span i18n="@@hero-tile.asset-library.none">None</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card"
              *ngFor="let heroTileData of displayHeroTiles | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize" [ngClass]="isDeviceMainTile ? 'custom-card-spacing' : ''">
              <div class="card-header small_text" id="segmentOne">
                <div class="acc_check" *ngIf="(presentPage === profilePage && globalconst.SRT_CONTENT === tabActive) || isDeviceMainTile">
                   <!--IIT2-6238 starts-->
                  <div id="addToProfileRadio" class="form-check">
                    <input type="radio" name="cpHeroSelect" class="form-check-input"
                      [value]="heroTileData?.showOnDevice" [checked]="heroTileData?.showOnDevice"
                      (change)="addToProfile(heroTileData,heroTileData.index,'srt')" />
                  </div>
                </div>
                <div id="addToPckgSec" class="acc_check" *ngIf="presentPage === profilePage && globalconst.CUSTOM_CONTENT === tabActive">
                  <div id="addToPckg" class="form-check" [ngbPopover]="(!heroTileData?.addToPackage) ? showonDeviceDisabled:''"
                  placement = 'right' triggers="mouseenter:mouseleave">
                    <input type="radio" name="cpHeroSelect" class="form-check-input"
                      [value]="heroTileData?.showOnDevice" [checked]="heroTileData?.showOnDevice"
                      (change)="addToProfile($event,heroTileData.index,'radio')"  [disabled]="!heroTileData.addToPackage"/>
                  </div>
                </div>
                 <!--IIT2-6238 ends-->
                <div id="publishNameCard" class="card-header-content">
                  <div id="publishNameTitle" class="title_left">
                    <div id="publishNameData" class="d-flex">
                      <div id="publishName" class="title">
                        <span>{{heroTileData?.publishedName}} &nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <div class="d-flex">
                    <div *ngIf="(heroTileData.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globalconst.CONT_GRP_EXPIRED_TEXT}}</span></div>
                    <div id="editHeroTileBtn" class="d-flex" *ngIf="(userRole === intelAdmin) && !isDeviceMainTile">
                      <button type="button" placement="bottom" ngbTooltip={{editTooltipLabel}}
                        (click)="editheroTile(heroTileData.id,tabActive,heroTileData)" class="btn gtmEditSegment">
                        <img alt="Edit" />
                      </button>
                      <button placement="bottom" ngbTooltip={{deleteTooltipLabel}}
                        (click)="openDeleteModal(heroTileData.id)" class="btn gtmDeleteSegment">
                        <img alt="Delete" />
                      </button>
                      <iposcen-delete-popup #deleteModal [contentName]="heroTileToDeleteName"
                        [buttonName]="mainTileAssetText" (delete)="deleteHeroTile(herTileoToDelete)">
                      </iposcen-delete-popup>
                      <button type="button" class="btn gtmSendPrice gtmSendBtn" placement="bottom"
                        ngbTooltip={{sendToStoresTooltipLabel}} container="body"
                        (click)="openSendToRetailerModal(heroTileData.id)">
                        <img alt="Send" />
                      </button>
                      <iposcen-send-to-retailer-popup #sendToRetailerModal [contentName]="heroTileToShareName"
                        [buttonName]="mainTileAssetText" [heroTileSuccess]="heroTileSuccessMsg"
                        [heroTileSuccessInfo]="heroTileSuccessInfoMsg" [description]="heroTileToShareDesc"
                        (sendHeroTile)="sendHeroTileToRetailer(heroTileToShare)"></iposcen-send-to-retailer-popup>
                    </div>
                    <div id="editCustomTileBtn" class="d-flex" *ngIf="!(userRole === intelAdmin) && !isDeviceMainTile">
                      <button *ngIf="globalconst.CUSTOM_CONTENT === tabActive && presentPage !== profilePage" type="button" placement="bottom" ngbTooltip={{editTooltipLabel}}
                        (click)="editCustomTile(heroTileData.id,heroTileData)" class="btn gtmEditSegment">
                        <img alt="Edit" />
                      </button>
                      <button *ngIf="presentPage !== profilePage" type="button" placement="bottom" ngbTooltip={{deleteTooltipLabel}}
                        (click)="openDeleteModal(heroTileData.id)" class="btn gtmDeleteSegment">
                        <img alt="Delete" />
                      </button>
                      <iposcen-delete-popup #deleteModal [contentName]="heroTileToDeleteName"
                        [buttonName]="'Content Group'" (delete)="deleteHeroTile(herTileoToDelete)">
                      </iposcen-delete-popup>
                      <button *ngIf="((isRetailerUser || isRegionalHQ) && presentPage !== profilePage) && globalconst.SRT_CONTENT !== tabActive && !isStoreUser" type="button" class="btn gtmSendBanner gtmSendBtn" placement="bottom" ngbTooltip={{optionalButton}}
                        container="body" (click)="openSendHeroTileData(heroTileData?.id)">
                        <img alt="Send" />
                      </button>
                    </div>
                  </div>
                </div>
                  <div *ngIf="!isDeviceMainTile" id="editAfterSent" class="other_data">
                    <div id="libNoneSec">
                      <div id="libNoneDesc" *ngIf="heroTileData?.isEditAfterSent" class="text-danger"><img class="exclamation"
                          alt="exclamation" />
                          <span class="exclamation-message-padding" i18n="@@hero-tile.content-must-be-updated">This
                            content has been updated. Share the latest version with the Retail HQ and Store
                          User.</span>
                      </div>
                      <div id="assetID" *ngIf="!isDeviceMainTile">
                      <iposcen-assetid-copy [assetID]="heroTileData?.id" *ngIf="presentPage === assetsPage">
                      </iposcen-assetid-copy>
                      <div id="heroTileSubTitle" class="subtitle_group">
                        <span class="subtitle"><span i18n="@@hero-tile.subtitle_group.create">Created By:</span>
                          {{heroTileData?.createdByUser}}</span>
                        <span class="subtitle"><span i18n="@@hero-tile.subtitle_group.create">Last Edited By</span>
                          {{heroTileData?.createdByUser}}:
                          {{heroTileData?.updateTime | dateFormat: "changeToLocalTimeZone"}}
                        </span>
                          <span class="subtitle" *ngIf="presentPage === assetsPage && userRole !== 'nonConnectedUser' && globalconst.CUSTOM_CONTENT === tabActive" i18n="@@price-content.group-tab.pushed">Pushed to all devices: {{heroTileData.ispushedToDevice ?'Y':'N'}}</span>
                        <span *ngIf="heroTileData?.internalName" class="subtitle"><span  i18n="@@hero-tile.asset-library.internal-name">Internal Name:</span>
                          {{heroTileData?.internalName}}
                        </span>
                      </div>
                       <!--IIT2-6238 starts-->
                      <div id="heroTileFormData" class="form-check mt-3" *ngIf="presentPage === profilePage && globalconst.CUSTOM_CONTENT === tabActive" [ngbPopover]="(selctedContGrpsForProfile.contentGrps?.length === 3 && !heroTileData.addToPackage) ? addToPackageDisabled:''"
                      placement="top-left" triggers="mouseenter:mouseleave">
                      <input class="form-check-input" type="checkbox" 
                      [value]="heroTileData?.addToPackage"
                      [checked]="heroTileData?.addToPackage"
                      (change)="addToProfile($event,heroTileData.index,'check')"
                      [id]="'addToPackOne'+heroTileData.index"
                      [disabled]="selctedContGrpsForProfile.contentGrps?.length === 3 && !heroTileData.addToPackage"
                         />
                      <label class="form-check-label" [for]="'addToPackOne'+heroTileData.index">
                        <span i18n="@@price-content.group-tab.add-to-package">Add to Package</span>
                      </label>
                    </div>
                     <!--IIT2-6238 ends-->
                    </div>
                    </div>
                  </div>
                </div>
                <div id="collapseLink" class="collapse_link collapsed collapse-button {{heroTileData?.id}}" type="button"
                  (click)="getDetailsOfHeroTile(heroTileData?.id)"
                  [ngClass]="heroTileData?.isExpanded ? 'transform-180' : ''">
                  <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                  </svg>
                </div>
              </div>
              <div id="collapseThree" class="collapse" #collapse="ngbCollapse"
                [(ngbCollapse)]="!heroTileData.isExpanded" aria-labelledby="logoCGThree"
                data-parent="#logoContentAccordian">              
                <div id="heroTileCardBody" class="card-body"
                  [ngClass]="(presentPage === profilePage || isDeviceMainTile) ? '':'card-body-asset'">
                  <div id="heroTileRow" class="row">
                    <div id="heroTileCol" class="col-md-6">
                    <ul  class="nav nav-tabs" role="tablist" *ngIf="heroTileData.configurations?.contentGroupPages?.length">
                      <li class="nav-item">
                          <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab" [ngClass]="{'active': heroTileData.previewTabIndex === 0}" (click)="previewNavigate(0, heroTileData.id)">
                              <span placement="top" container='body' i18n="@@hero-tile.asset-library.main-content">Main content</span>
                          </a>
                      </li>
                      <li class="nav-item">
                          <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab" [ngClass]="{'active': heroTileData.previewTabIndex === 1}" (click)="previewNavigate(1, heroTileData.id)">
                              <span placement="top" container='body' i18n="@@hero-tile.asset-library.page-content">Page contents</span>
                          </a>
                      </li>                  
                    </ul>
                    </div>
                    <div id="duplicateTile" class="col-md-6 float-right">
                      <div id="duplicateTileBtnSec" *ngIf="globalconst.CUSTOM_CONTENT === tabActive && !isDeviceMainTile" class="duplicate-and-edit-span float-right">
                          <div id="duplicateTileBtn" class="btn btn-primary button-duplicate" (click)="duplicateCustomTile(heroTileData)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                                fill="white" />
                              <path
                                d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                                fill="white" />
                            </svg>
                            <span i18n="@@banner-carousel.collapse-link.duplicate-edit">Duplicate and Edit</span>
                          </div>
                        </div>
                      </div>
                      </div>                     
                  <div id="priceTab" class="tab-content mt-3">
                    <table class="table-borderless" aria-describedby="price content table" *ngIf="globalconst.CUSTOM_CONTENT === tabActive && heroTileData.previewTabIndex === 0">
                      <tr>
                        <th scope="col"><span i18n="@@price-content.group-tab.publish-date-time">Publishing Date and
                            Time</span></th>
                        <th scope="col"><span i18n="@@price-content.group-tab.expiration-date-time">Expiration Date
                            and Time</span></th>
                      </tr>
                      <tr>
                        <td>{{heroTileData?.configurations?.publishTime | dateFormat: "24hrP"}}</td>
                        <td>{{heroTileData?.configurations?.expireTime | dateFormat: "24hrP"}}</td>
                      </tr>
                    </table>                     
                      <div id="heroData" *ngIf="heroTileData.previewTabIndex === 0" id="storeLogos" class="tab-pane pl-0 view_herotile_details" [ngClass]="{'active': heroTileData.previewTabIndex === 0}">
                        <div id="heroImgSec" class="tile_image" [ngClass]="presentPage === profilePage?'profile_tile_image':''">
                          <div id="heroImg" class="image-section">
                            <img src={{heroTileData?.heroImageURL}} alt="Main Tile image" />
                          </div>
                          <!-- ashutosh removing this *ngIf so to display main tile image in preview  -->
                          <div id="imgInfoSec" class="image-info-section" >
                            <legend><span i18n="@@hero-tile.hero-tile-image">Main Tile Image</span></legend>
                            <div>{{heroTileData?.heroImageFile}}</div>
                          </div>
                        </div>
                        <!-- ashutosh removing this *ngIf so to display main tile image in preview  -->
                        <div id="tileImage" class="tile_image" >
                          <div id="imgSec" class="image-section">
                            <img src={{heroTileData?.gamingImageURL}} alt="Main Tile image" />
                          </div>
                          <div id="gamingImg" class="image-info-section">
                            <legend><span i18n="@@hero-tile.gaming-hero-tile-image">Gaming IPOS Banner</span></legend>
                            <div>{{heroTileData?.gamingImageFile}}</div>
                          </div>
                        </div>
                        <div id="mainTileData" class="tile_data">
                          <div id="mainTileImg" class="mb-4 name-break" *ngIf="presentPage === profilePage">
                            <legend><span i18n="@@hero-tile.hero-tile-image">Main Tile Image</span></legend>
                            <div>{{heroTileData?.heroImageFile}}</div>
                          </div>
                          <div id="callToActionHero" class="mb-2 name-break">
                            <legend><span i18n="@@hero-tile.call-to-action">Call-to-Action</span></legend>
                            <div id="callToActionTxt">{{heroTileData?.callToAction}}</div>
                          </div>
                          <ng-container *ngIf="globalconst.SRT_CONTENT === tabActive ;else formFactors">
                            <div id="srtUrlHero" class="mb-4 name-break">
                              <legend><span i18n="@@hero-tile.srt-url">Intel® Shopper Recommendation Tool URL</span>
                              </legend>
                              <div>{{heroTileData?.srtUrl}}</div>
                            </div>
                            <div id="zipFileHero" class="name-break">
                              <legend><span i18n="@@hero-tile.fallback-zip-file-info">Fallback Zip File</span></legend>
                              <div>{{heroTileData?.fallbackExeFile}}</div>
                            </div>
                          </ng-container>
                          <ng-template #formFactors>
                            <div id="nameBreak" class="name-break">
                              <table class="table-borderless form-factors-main-div" aria-describedby="formFactors">
                                <tr>
                                  <th scope="col" class="pb-1"><span i18n="@@banner-carousel.content-group-applies-to">Content Group
                                      Applies
                                      To</span>: </th>
                                </tr>
                                <tr>
                                  <td><strong><span>{{globalconst.MANUFACTURERS}}</span>:</strong>
                                    {{ heroTileData?.formFactor?.manufacturer.length ?
                                    heroTileData?.formFactor?.manufacturer : globalconst.ALL}}
                                  </td>
                                </tr>
                                <tr>
                                  <td><strong><span>{{globalconst.DEVICE_TYPES}}</span>: </strong>
                                    {{ heroTileData?.formFactor?.devices.length ? heroTileData?.formFactor?.devices : globalconst.ALL}}
                                  </td>
                                </tr>
                                <tr>
                                  <td><strong><span>{{globalconst.PROCESSORS}}</span>: </strong>
                                    {{ heroTileData?.formFactor?.processors.length ? heroTileData?.formFactor?.processors :
                                    globalconst.ALL}}
                                  </td>
                                </tr>
                                <tr>
                                  <td><strong><span>{{globalconst.GENERATION}}</span>:</strong>
                                    {{ heroTileData?.formFactor?.generations.length ? heroTileData?.formFactor?.generations :
                                    globalconst.ALL}}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                      <div id="newwinPage" *ngIf="heroTileData.previewTabIndex === 1" id="storeLogos" class="tab-pane pl-0" [ngClass]="{'active': heroTileData.previewTabIndex === 1}">
                        <div id="detailPage" class="detailpage__content newwin_detail_page">
                          <div id="detailContainer" class="main-container">
                            <div id="detailData" class="d-flex ">
                              <ng-container *ngFor="let page of heroTileData.configurations.contentGroupPages"> 
                                  <iposcen-mini-live-preview [data]="loadMiniPreview(heroTileData?.id,page)">
                                  </iposcen-mini-live-preview>
                              </ng-container>
                            </div>  
                          </div>
                      </div>
                      </div>
                  </div>  
                </div>
              </div>
            </div>
            <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendNameToStore" [sendButtonName]="sendButtonText"
              (selectedStoreData)="getSelectedStoreData($event)" [sendToStoreSuccess]="isSendToStore"
              (clearAllData)="isSendToStore=false">
            </iposcen-send-to-segment-account>
          </div>
        </div>

        <!-- Data Footer - Pagination -->
        <div id="heroDataFooter" class="data_footer" *ngIf="displayHeroTiles?.length > 0 &&((displayHeroTiles && operatingSystem !== chrome && presentPage === profilePage) || (presentPage === assetsPage && displayHeroTiles) || isDeviceMainTile )">
          <nav aria-label="hero tile pagination">
            <ngb-pagination [collectionSize]="displayHeroTiles.length" [(page)]="page" [maxSize]="maxSize"
              [pageSize]="pageSize" [rotate]="true" [boundaryLinks]="false"></ngb-pagination>
          </nav>
        </div>

        <ng-container *ngIf="presentPage === profilePage">
          <div id="btnWrapper" class="button-wrapper justify-content-end" *ngIf="presentPage === profilePage">
            <button type="button" class="btn btn-outline-primary btn-lg gtmAssetLibraryHeroTileSkip"
              (click)="sendToProfile('skip')">
              <span i18n="@@hero-tile.skip">Skip</span>
            </button>
            <button type="button" class="btn btn-primary btn-lg gtmAssetLibraryHeroTileSaveAndContinue"
              (click)="sendToProfile('send')" [disabled]= "displayHeroTiles?.length === 0">
              <span class="gtmAssetLibraryHeroTileSaveAndContinue" i18n="@@logo-content.logo-content-groups.save-and-continue">Save and
                Continue</span>
            </button>
          </div>
        </ng-container>
      </div>
</div>
    </div>
  </section>
  <section *ngIf="tabIndex === 1 || tabIndex === 2" class="main_section_with_preview">
    <iposcen-create-hero-tile [pageType]="pageType" (goBacktoHeroTileLists)="setCreatedGrpID($event)"
      (refreshHeroTiledata)="refreshHeroTiledata(globalconst.SRT_CONTENT)" (ctatextvalue)="setCTAValue($event)"></iposcen-create-hero-tile>
  </section>
  <section *ngIf="tabIndex === 3">
    <iposcen-custom-tile [editObject]="sendEditData" (showOnDeviceTile)="showOnDeviceTile($event)" (closeCustomDevice)="closeCustomDevice($event)" (refresh)="refreshHeroTiledata(globalconst.CUSTOM_CONTENT)"></iposcen-custom-tile>
  </section>
</div>
<ng-template #addButtonCustom>
  <span class="data_action"
    *ngIf="(presentPage === assetsPage|| presentPage === profilePage) && globalconst.CUSTOM_CONTENT === tabActive">
    <button type="button" id="uploadpromo"
      class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryHeroTileNewHeroTile" (click)="newCustomMainTile()">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
      <span i18n="@@hero-tile.asset-library.new-custom-main-tile-content">New Custom Main Tile Content</span>
    </button>
  </span>
</ng-template>
<ng-template #noDataMessage>
    <div id="customeSRTNote">
      <span i18n="@@hero-tile.asset-library.custom-srt-added-as-asset"><strong>Note:</strong> The Custom content and Intel® SRT can both be added as assets in the Main Tile.</span>
    </div>
    <!-- <span i18n="@@hero-tile.asset-Library.no-content">Main Tile is enabled by Intel Admin, you will receive the
      content group shortly.</span> -->
      <div id="toolContent" class="mt-3">
        <span i18n="@@hero-tile.asset-library.intel-shopper-tool-content-group-intel-admin">Intel® Shopper Recommendation Tool Content Groups can only be created by Intel Admin. 
          Contact an Intel representative to receive the content groups which can be used in a profile.</span>
      </div>
</ng-template>
<ng-template #noDataCustomTile>
  <span i18n="@@hero-tile.informational-mainTile-text">Main Tile can be customized through the content groups created here.</span>
</ng-template>